import React from 'react';
import CheckCircleIcon from '@atlaskit/icon/glyph/check-circle';
import ErrorIcon from '@atlaskit/icon/glyph/error';
import InfoIcon from '@atlaskit/icon/glyph/info';
import QuestionCircleIcon from '@atlaskit/icon/glyph/question-circle';
import WarningIcon from '@atlaskit/icon/glyph/warning';
import { B50, B500, G50, G500, P50, P500, R50, R500, Y50, Y500 } from '@atlaskit/theme/colors';
export const appearanceIconSchema = {
  information: {
    backgroundColor: `var(--ds-background-information, ${B50})`,
    Icon: InfoIcon,
    primaryIconColor: `var(--ds-icon-information, ${B500})`
  },
  warning: {
    backgroundColor: `var(--ds-background-warning, ${Y50})`,
    Icon: WarningIcon,
    primaryIconColor: `var(--ds-icon-warning, ${Y500})`
  },
  error: {
    backgroundColor: `var(--ds-background-danger, ${R50})`,
    Icon: ErrorIcon,
    primaryIconColor: `var(--ds-icon-danger, ${R500})`
  },
  success: {
    backgroundColor: `var(--ds-background-success, ${G50})`,
    Icon: CheckCircleIcon,
    primaryIconColor: `var(--ds-icon-success, ${G500})`
  },
  discovery: {
    backgroundColor: `var(--ds-background-discovery, ${P50})`,
    Icon: QuestionCircleIcon,
    primaryIconColor: `var(--ds-icon-discovery, ${P500})`
  }
};
export function getAppearanceIconStyles(appearance, icon) {
  const appearanceIconStyles = appearanceIconSchema[appearance] || appearanceIconSchema.information;
  const AppearanceIcon = ({
    size,
    primaryColor,
    secondaryColor
  }) => /*#__PURE__*/React.createElement(appearanceIconStyles.Icon, {
    size: size,
    primaryColor: primaryColor,
    secondaryColor: secondaryColor,
    label: appearance
  });
  const Icon = icon || AppearanceIcon;
  return {
    ...appearanceIconStyles,
    Icon
  };
}